import _ from 'underscore';
import { getRoutePathById } from '@bingads-webui-campaign-react/with-site-map';
/* global Map */

const toolbarItemsWithoutSelection = ({
  i18n, permissions, scope, siteMap,
}) => ([
  ...(permissions && permissions.CustomReportBuilder ? [
    ['button-create', {
      id: 'button-create',
      type: 'button',
      classes: ['btn-primary'],
      iconLeftGlyphName: 'ba-Add',
      text: i18n.getString(_TL_('Create report')),
      onClick: () => {
        scope.save(getRoutePathById(siteMap, 'reporting-build-custom-report'));
      },
    }],
  ] : []),
  ['predicate-list', {
    id: 'predicate-list',
    type: 'custom',
  }],
  ['expander', {
    type: 'expander',
  }],
  ['search-box-filter', {
    id: 'search-box-filter',
    type: 'search-box',
    placeholder: i18n.getString(_TL_('Report Name')),
  }],
]);


const toolbarItemWithSelect = ({
  i18n, type, selectedItems, reportDuplicate, reportDownload, reportDelete,
}) => ([
  ['selection-widget', {
    id: 'selection-widget',
    type: 'selection-widget',
  }],
  ['button-duplicate', {
    id: 'button-duplicate',
    type: 'button',
    classes: ['btn-link'],
    iconLeftGlyphName: 'ba-Copy',
    text: i18n.getString(_TL_('Duplicate')),
    onClick: () => {
      reportDuplicate();
    },
    isHide: selectedItems.length > 1,
  }],
  ['button-download', {
    id: 'button-download',
    type: 'button',
    classes: ['btn-link'],
    iconLeftGlyphName: 'ba-Download',
    text: i18n.getString(_TL_('Download')),
    onClick: () => {
      reportDownload();
    },
    isHide: selectedItems.length > 1,
  }],
  ['button-delete', {
    id: 'button-delete',
    type: 'button',
    classes: ['btn-link'],
    iconLeftGlyphName: 'ba-Delete',
    text: i18n.getString(_TL_('Delete')),
    onClick: () => {
      reportDelete();
    },
    isHide: type === 'Shared',
  }],
  ['expander', {
    type: 'expander',
  }],
  ['button-clear-selection', {
    id: 'button-clear-selection',
    type: 'button-clear-selection',
  }],
]);

export function getMyReportsGridToolbarConfig({
  i18n, type, selectedItems, permissions, scope, siteMap, reportDuplicate, reportDownload, reportDelete,
}) {
  const toolbarUnselectedConfig = new Map();
  toolbarItemsWithoutSelection({
    i18n, permissions, scope, siteMap,
  }).forEach(([key, value]) => {
    toolbarUnselectedConfig.set(key, value);
  });

  const toolbarSelectedConfig = new Map();
  toolbarItemWithSelect({
    i18n, type, selectedItems, reportDuplicate, reportDownload, reportDelete,
  }).forEach(([key, value]) => {
    if (!value.isHide) {
      toolbarSelectedConfig.set(key, _.omit(value, 'isHide'));
    }
  });

  return {
    toolbarUnselectedConfig,
    toolbarSelectedConfig,
  };
}
